import { List } from "antd-mobile";
import { useTranslateContext } from "fennec-ui";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { useNavigate } from 'react-router';
import { access, level } from "../../../common/Tool";

export default function MenuLevelOne({ menu, menuClose, getStack }) {
    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status);
    const notify = useSelector(state => state.home.notify);
    const t = useTranslateContext();

    const navigateTo = useNavigate();
    const navLinkClick = (e, path) => {
        e.stopPropagation();
        e.preventDefault();
        let stack = getStack();
        stack.push(() => {
            navigateTo(path);
        })
        menuClose()
    }

    let _menu = level(menu, "", role_by_id)
    if (_menu.length <= 0) return (<></>);
    // const elements = _menu.map((element, index) => {
    //     const key = element.uuid || element.key || index;
    //     return (
    //         <List.Item key={key}>
    //             <NavLink key={key} to={key} onClick={(e)=>{navLinkClick(e, key)}}>
    //                 {({ isActive }) =>
    //                     <span style={{ fontSize: "14px", fontWeight: "400", color: (isActive) ? "#001529" : "rgb(148, 148, 148)" }}>{element.name}</span>
    //                 }
    //             </NavLink>
    //         </List.Item>
    //     )
    // })
    const elements = _menu.map((e, index) => {
        const key = e.uuid || e.key || index;
        if (e.hidden || e.unvisible) {
            return
        }
        if (e.component && access(e, role_by_id)) {
            // return (<List.Item key={key}>{e.name}</List.Item>)
            return (
                <List.Item key={key}>
                    <NavLink key={key} to={key} onClick={(e) => { navLinkClick(e, key) }}>
                        {({ isActive }) =>
                            <span style={{ fontSize: "14px", fontWeight: "400", color: (isActive) ? "#001529" : "rgb(148, 148, 148)" }}>{e.name}</span>
                        }
                    </NavLink>
                </List.Item>
            )
        }
    })
    return (
        <List className={"menu-level-one"}>
            {elements}
        </List>
    )
}